export default __webpack_public_path__ + "static/media/up-dotted-border.63c09f70.svg";